import React, { Component } from 'react';
import get from 'lodash/get';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import WebsiteFormFields from './WebsiteFormFields';

class WebsiteModal extends Component {
  render() {
    const { show, handleHide, handleSubmit, formAction, isLoading, website, onFormSubmit } = this.props;

    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>{formAction} Website</Modal.Title>
        </Modal.Header>

        <form
          onSubmit={handleSubmit(onFormSubmit.bind(this, handleHide))}
          className='m-t'
        >
          <Modal.Body>
            <WebsiteFormFields website={website} formAction={formAction} />
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={handleHide}>Close</Button>
            <Button
              type='submit'
              loading={isLoading}
              bsStyle='primary'
            >
              {formAction || 'Submit'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const ResourceModal = connectModal({
  name: 'WebsiteFormModal'
});

const ResourceForm = reduxForm({
  form: 'WebsiteForm'
});

const mapStateToProps = (state, ownProps) => {
  const { loader, modal } = state;
  const { onFormSubmit } = ownProps;
  const website = get(modal, 'WebsiteFormModal.props.website', null);
  const formAction = get(modal, 'WebsiteFormModal.props.formAction', null);
  const isLoading = loader.includes('WebsiteForm');
  const initialValues = { website: {} };

  if (formAction === 'Update') {
    initialValues.website = {
      name: website.name,
      url: website.url,
      cpa: website.cpa,
      cpc: website.cpc,
      default_slots: website.default_slots,
      sandbox: website.sandbox === true ? 'sandbox' : 'live'
    };
  }

  return { isLoading, onFormSubmit, website, formAction, initialValues };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(WebsiteModal)));
